import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-full col-span-1 text-center bg-white border divide-y divide-gray-200 shadow-sm rounded-t-2xl" }
const _hoisted_2 = {
  key: 0,
  class: "p-2 quiz-pass-ribbon"
}
const _hoisted_3 = { class: "flex flex-col flex-1 p-8" }
const _hoisted_4 = ["href", "alt", "title"]
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "flex flex-col justify-between flex-grow mt-1" }
const _hoisted_7 = { class: "text-sm text-clay-800" }
const _hoisted_8 = { class: "items-center mt-3 text-center" }
const _hoisted_9 = {
  key: 0,
  class: "inline-flex inline-flex px-2 py-1 m-1 mb-2 text-xs font-medium border rounded-full text-electric-700 bg-electric-50 hover:border-electric-500 hover:border"
}
const _hoisted_10 = {
  key: 1,
  class: "inline-flex inline-flex px-2 py-1 m-1 mb-2 text-xs font-medium border rounded-full text-electric-700 bg-electric-50 hover:border-electric-500 hover:border"
}
const _hoisted_11 = {
  key: 2,
  class: "inline-flex inline-flex px-2 py-1 m-1 mb-2 text-xs font-medium border rounded-full text-electric-700 bg-electric-50 hover:border-electric-500 hover:border"
}
const _hoisted_12 = {
  key: 1,
  class: "bg-gradient-to-b from-green-200"
}
const _hoisted_13 = { class: "flex -mt-px divide-x divide-gray-200" }
const _hoisted_14 = { class: "flex flex-1 w-0" }
const _hoisted_15 = { class: "relative inline-flex items-center justify-center flex-1 w-0 py-2 -mr-px text-xs font-medium text-gray-700 border border-transparent rounded-bl-lg" }
const _hoisted_16 = {
  class: "font-small",
  style: {"font-size":"0.85rem"}
}
const _hoisted_17 = { class: "flex flex-1 w-0 -ml-px" }
const _hoisted_18 = { class: "relative inline-flex items-center justify-center flex-1 w-0 px-3 py-2 text-xs font-medium text-gray-700 border border-transparent rounded-br-lg" }
const _hoisted_19 = { class: "w-full px-2 py-2 font-bold" }
const _hoisted_20 = { class: "flex -mt-px divide-x divide-gray-200" }
const _hoisted_21 = { class: "flex flex-1 w-0 px-3 py-2" }
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  key: 2,
  class: "bg-gradient-to-b from-amber-200"
}
const _hoisted_24 = { class: "flex -mt-px divide-x divide-gray-200" }
const _hoisted_25 = { class: "flex flex-1 w-0" }
const _hoisted_26 = { class: "relative inline-flex items-center justify-center flex-1 w-0 py-2 -mr-px text-xs font-medium text-gray-700 border border-transparent rounded-bl-lg" }
const _hoisted_27 = {
  class: "for-level-intermediate font-small",
  style: {"font-size":"0.85rem"}
}
const _hoisted_28 = { class: "flex flex-1 w-0 -ml-px" }
const _hoisted_29 = { class: "relative inline-flex items-center justify-center flex-1 w-0 px-3 py-2 text-xs font-medium text-gray-700 border border-transparent rounded-br-lg" }
const _hoisted_30 = { class: "w-full px-2 py-2 font-bold" }
const _hoisted_31 = { class: "flex -mt-px divide-x divide-gray-200" }
const _hoisted_32 = { class: "flex flex-1 w-0 px-3 py-2" }
const _hoisted_33 = ["href"]
const _hoisted_34 = {
  key: 3,
  class: "bg-gradient-to-b from-rose-200"
}
const _hoisted_35 = { class: "flex -mt-px divide-x divide-gray-200" }
const _hoisted_36 = { class: "flex flex-1 w-0" }
const _hoisted_37 = { class: "relative inline-flex items-center justify-center flex-1 w-0 py-2 -mr-px text-xs font-medium text-gray-700 border border-transparent rounded-bl-lg" }
const _hoisted_38 = {
  class: "for-level-advanced font-small",
  style: {"font-size":"0.85rem"}
}
const _hoisted_39 = { class: "flex flex-1 w-0 -ml-px" }
const _hoisted_40 = { class: "relative inline-flex items-center justify-center flex-1 w-0 px-3 py-2 text-xs font-medium text-gray-700 border border-transparent rounded-br-lg" }
const _hoisted_41 = { class: "w-full px-2 py-2 font-bold" }
const _hoisted_42 = { class: "flex -mt-px divide-x divide-gray-200" }
const _hoisted_43 = { class: "flex flex-1 w-0 px-3 py-2" }
const _hoisted_44 = ["href"]

import {onMounted, ref} from "vue";
import {store} from "@/store";
import {QuizDTO} from "@/dtos";
import {BoltIcon as BoltIconSolid} from '@heroicons/vue/24/solid';
import {BoltIcon as BoltIconOutline} from '@heroicons/vue/24/outline';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuizCard',
  props: {
    quiz: {},
},
  setup(__props) {

// @ts-ignore
const props = __props

const quiz: QuizDTO = props.quiz;
let isPassed: boolean = ref(false);

onMounted((): void => {
    if (store.saUserSession.completedQuizItems.includes(quiz.id.toLowerCase())) {
        isPassed = true;
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isPassed))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "py-1 text-sm font-semibold text-white bg-sa-red-500 rounded-xl" }, [
            _createElementVNode("i", {
              "aria-hidden": "true",
              class: "mr-1 fas fa-check opacity-80"
            }),
            _createElementVNode("span", null, "Passed!")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        href: `/${_unref(quiz).id}/${_unref(quiz).slug}`,
        alt: _unref(quiz).title,
        title: _unref(quiz).title,
        class: "text-lg font-medium text-gray-900 hover:underline hover:decoration-cyan-500 hover:transition-all hover:decoration-2"
      }, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(quiz).title), 1)
      ], 8, _hoisted_4),
      _createElementVNode("dl", _hoisted_6, [
        _cache[1] || (_cache[1] = _createElementVNode("dt", { class: "sr-only" }, "Description", -1)),
        _createElementVNode("dd", _hoisted_7, _toDisplayString(_unref(quiz).description), 1),
        _cache[2] || (_cache[2] = _createElementVNode("dt", { class: "sr-only" }, "Guide Type", -1)),
        _createElementVNode("dd", _hoisted_8, [
          (_unref(quiz).hasAssociatedShowGuides)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Shows"))
            : _createCommentVNode("", true),
          (_unref(quiz).hasAssociatedAuthorGuides)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Writers"))
            : _createCommentVNode("", true),
          (!_unref(quiz).hasAssociatedGuides)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "General Theatre"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_unref(quiz).difficultyLevelIndicator === 'beginner')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[3] || (_cache[3] = _createTextVNode(" Level: ")),
                    _createVNode(_unref(BoltIconSolid), { class: "inline-block w-4 h-4" }),
                    _createVNode(_unref(BoltIconOutline), { class: "inline-block w-4 h-4" }),
                    _createVNode(_unref(BoltIconOutline), { class: "inline-block w-4 h-4" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(quiz).points) + " points", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("a", {
                class: "relative inline-flex items-center justify-center flex-1 w-0 py-2 -mr-px font-medium text-white border border-transparent rounded-md shadow-sm bg-clay-800 hover:bg-clay-800 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-clay-500",
                href: `/${_unref(quiz).id}/${_unref(quiz).slug}`
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("span", { class: "start-quiz" }, "Start Quiz", -1)
              ]), 8, _hoisted_22)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(quiz).difficultyLevelIndicator === 'intermediate')
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_27, [
                    _cache[5] || (_cache[5] = _createTextVNode(" Level: ")),
                    _createVNode(_unref(BoltIconSolid), { class: "inline-block w-4 h-4" }),
                    _createVNode(_unref(BoltIconSolid), { class: "inline-block w-4 h-4" }),
                    _createVNode(_unref(BoltIconOutline), { class: "inline-block w-4 h-4" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(quiz).points) + " points", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("a", {
                class: "relative inline-flex items-center justify-center flex-1 w-0 py-2 -mr-px font-medium text-white border border-transparent rounded-md shadow-sm bg-clay-800 hover:bg-clay-800 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-clay-500",
                href: `/${_unref(quiz).id}/${_unref(quiz).slug}`
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("span", { class: "start-quiz" }, "Start Quiz", -1)
              ]), 8, _hoisted_33)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(quiz).difficultyLevelIndicator === 'advanced')
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_38, [
                    _cache[7] || (_cache[7] = _createTextVNode(" Level: ")),
                    _createVNode(_unref(BoltIconSolid), { class: "inline-block w-4 h-4" }),
                    _createVNode(_unref(BoltIconSolid), { class: "inline-block w-4 h-4" }),
                    _createVNode(_unref(BoltIconSolid), { class: "inline-block w-4 h-4" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(quiz).points) + " points", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("a", {
                class: "relative inline-flex items-center justify-center flex-1 w-0 py-2 -mr-px font-medium text-white border border-transparent rounded-md shadow-sm bg-clay-800 hover:bg-clay-800 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-clay-500",
                href: `/${_unref(quiz).id}/${_unref(quiz).slug}`
              }, _cache[8] || (_cache[8] = [
                _createElementVNode("span", { class: "start-quiz" }, "Start Quiz", -1)
              ]), 8, _hoisted_44)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})